var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "followUpRecord" }, [
    _c("div", { staticClass: "addContent" }, [
      _c("div", { staticClass: "left" }, [
        _c("img", {
          staticClass: "head-portrait",
          attrs: { src: _vm.avatar, alt: "" },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c(
            "div",
            { staticClass: "box", on: { click: _vm.focusFn } },
            [
              _c("el-input", {
                ref: "inputFocus",
                attrs: {
                  autosize: "",
                  placeholder: "填写跟进记录吧",
                  resize: "none",
                  type: "textarea",
                },
                model: {
                  value: _vm.form.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "uploadBox" },
                _vm._l(_vm.uploadList, function (item, i) {
                  return _c(
                    "el-tag",
                    { key: i, staticClass: "mt10", attrs: { type: "info" } },
                    [
                      _c("div", { staticClass: "info" }, [
                        _c("i", {
                          staticClass: "el-icon-error",
                          on: {
                            click: function ($event) {
                              return _vm.deleteTag(item)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.toSrc(item.real_name) === 1
                          ? _c("img", {
                              staticClass: "img",
                              attrs: {
                                alt: "",
                                src: require("@/assets/images/doc.png"),
                              },
                            })
                          : _vm.toSrc(item.real_name) === 2
                          ? _c("img", {
                              staticClass: "img",
                              attrs: {
                                alt: "",
                                src: require("@/assets/images/ppt.png"),
                              },
                            })
                          : _vm.toSrc(item.real_name) === 3
                          ? _c("img", {
                              staticClass: "img",
                              attrs: {
                                alt: "",
                                src: require("@/assets/images/xls.png"),
                              },
                            })
                          : _vm.toSrc(item.real_name) === 4
                          ? _c("img", {
                              staticClass: "img",
                              attrs: {
                                alt: "",
                                src: require("@/assets/images/record2.png"),
                              },
                            })
                          : _vm.toSrc(item.real_name) === 5
                          ? _c("img", {
                              staticClass: "img",
                              attrs: {
                                alt: "",
                                src: require("@/assets/images/pdf.png"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-info line1" }, [
                          _vm._v(_vm._s(item.real_name)),
                        ]),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "footer" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 12 } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "mr10 upload-real",
                      attrs: {
                        headers: _vm.myHeaders,
                        "http-request": _vm.uploadServerLog,
                        "show-file-list": false,
                        action: "##",
                      },
                    },
                    [
                      !_vm.percentShow
                        ? _c("div", { staticClass: "addText" }, [
                            _c("span", { staticClass: "iconfont iconfujian" }),
                            _vm._v(" 添加文件"),
                          ])
                        : _c("div", { staticClass: "addText" }, [
                            _c("img", {
                              staticClass: "l_gif",
                              attrs: {
                                alt: "",
                                src: require("@/assets/images/loading.gif"),
                              },
                            }),
                          ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "text-right", attrs: { span: 12 } },
                [
                  _vm.formInfo.type === "edit"
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.clientCancel },
                        },
                        [_vm._v("取消")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.loading,
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.clientFollowSave },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.formInfo.show !== 1
            ? _c("div", { staticClass: "splitLine mt30" })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }